import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useContextSystem } from '@wp-g2/context';
import { cx } from '@wp-g2/styles';
import { useUniqueId } from '@wp-g2/utils';
import * as styles from './FormGroup.styles';
/**
 * @typedef OwnProps
 * @property {Pick<import('../Text/types').Props, 'align'>} [alignLabel='left']
 * @property {boolean} [horizontal=true]
 * @property {string} [label]
 * @property {string} [help]
 * @property {boolean} [labelHidden=false]
 * @property {boolean} [truncate=false]
 */

/** @typedef {import('../Grid/types').Props & OwnProps} Props */

/**
 * @param {import('@wp-g2/create-styles').ViewOwnProps<Props, 'div'>} props
 */

export function useFormGroup(props) {
  var _useContextSystem = useContextSystem(props, 'FormGroup'),
      _useContextSystem$ali = _useContextSystem.alignLabel,
      alignLabel = _useContextSystem$ali === void 0 ? 'left' : _useContextSystem$ali,
      children = _useContextSystem.children,
      className = _useContextSystem.className,
      help = _useContextSystem.help,
      _useContextSystem$hor = _useContextSystem.horizontal,
      horizontal = _useContextSystem$hor === void 0 ? false : _useContextSystem$hor,
      idProp = _useContextSystem.id,
      label = _useContextSystem.label,
      _useContextSystem$lab = _useContextSystem.labelHidden,
      labelHidden = _useContextSystem$lab === void 0 ? false : _useContextSystem$lab,
      _useContextSystem$tru = _useContextSystem.truncate,
      truncate = _useContextSystem$tru === void 0 ? false : _useContextSystem$tru,
      otherProps = _objectWithoutProperties(_useContextSystem, ["alignLabel", "children", "className", "help", "horizontal", "id", "label", "labelHidden", "truncate"]);

  var id = useUniqueId(useFormGroup, 'form-group', idProp);
  var classes = cx(styles.FormGroup, className);
  return _objectSpread(_objectSpread({}, otherProps), {}, {
    className: classes,
    contentProps: {
      alignLabel: alignLabel,
      children: children,
      help: help,
      id: id,
      horizontal: horizontal,
      label: label,
      labelHidden: labelHidden,
      truncate: truncate
    },
    horizontal: horizontal
  });
}